/* import __COLOCATED_TEMPLATE__ from './connect-button-dropdown-item.hbs'; */
/* RESPONSIBLE TEAM: team-fin-voice */
import templateOnlyComponent from '@ember/component/template-only';

export interface ConnectButtonDropdownItemArgs {
  item: {
    value: string;
    text: string;
    isSelected: boolean;
  };
}

interface Signature {
  Args: ConnectButtonDropdownItemArgs;
  Element: HTMLElement;
}

const ConnectButtonDropdownItem = templateOnlyComponent<Signature>();
export default ConnectButtonDropdownItem;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'AiAgent::VoicePlayground::ConnectButtonDropdownItem': typeof ConnectButtonDropdownItem;
  }
}
